export default __webpack_public_path__ + "static/media/tex-gyre-adventor-regular.6268d592.woff2";